export default {
  view: {
    attendance: {
      filter: {
        title: 'Filters',
        eventTypes: 'Event Types',
        all: 'All',
        none: 'None',
        search: 'Search',
      },
      origin: {
        email: 'E-mail',
        order: 'Order',
        calendar: 'Calendar',
        process: 'Process',
        conversation: 'Conversation',
        surveynps: 'NPS Survey',
        call: 'Call',
        audio: 'Visit Audio',
        evotalks: 'EvoTalks',
      },
      card: {
        email: {
          to: 'To:',
        },
        order: {
          situation: 'Status',
          netValue: 'Net Value',
          discountPct: '% Discount',
          discountValue: 'Discount Value',
          grossValue: 'Gross Value',
          viewDetails: 'View full details',
          notFound: 'Order data not found',
        },
        call: {
          protocol: 'Protocol',
          type: 'Type',
          notFound: 'Call data not found',
          contact: 'Contact/Number',
          duration: 'Duration',
        },
        conversation: {
          contact: 'Contact/Number',
          department: 'Department',
          startDate: 'Start',
          endDate: 'End',
        },
        nps: {
          situation: 'Status',
          order: 'Order',
          score: 'Score',
          comment: 'Comment',
        },
        process: {
          follow: 'Follow',
          openError: 'Unable to open the process.',
        },
      },
      engagementCard: {
        title: 'Engagement Score',
        tooltip: 'The score is calculated based on the frequency and recency of client interactions (emails, orders, conversations, calls and visits). More recent and frequent interactions raise the score. 0–39% = low engagement | 40–69% = medium engagement | 70–100% = highly active client (Power User).',
        lowIntent: 'LOW INTENT',
        powerUser: 'POWER USER',
        totalInteractions: 'Total Interactions',
        lastActivity: 'Last Activity',
        noData: 'No engagement data',
        fewMinutesAgo: 'a few min ago',
        hoursAgo: '{hours}h ago',
        oneDayAgo: '1 day ago',
        daysAgo: '{days} days ago',
        oneMonthAgo: '1 month ago',
        monthsAgo: '{months} months ago',
      },
      statsCard: {
        title: 'Period Summary',
        events: 'Events',
        moved: 'Total Value',
        distributionByType: 'Distribution by type',
        noEvents: 'No events in this period',
      },
    },
    order: {
      grid: {
        invoiceNumber: 'Invoice number',
        invoiceIssuanceDate: 'Invoice issuance date',
      },
    },
  },
  chat: {
    filters: {
      unread: 'Unread',
      pinned: 'Pinned',
      unassigned: 'Unassigned',
    },
    messages: {
      errorTogglingPin: 'Error toggling pin/unpin conversation',
    },
    dialog: {
      salesChannel: {
        title: 'Sales Channel',
        message: 'The sales channel number has not been configured. Please configure it to continue.',
      },
    },
  },
  clientSearchField: {
    client: 'Client',
    prospect: 'Prospect',
    searchForAClient: 'Search for a client',
    searchForAProspect: 'Search for a prospect',
    copyText: 'Copy name',
    textCopied: 'Name copied to clipboard',
    copyFailed: 'Failed to copy name',
  },
  prospectForm: {
    integrationFields: {
      sectionTitle: 'Integration Fields',
      empty: 'No integration field filled',
      emptyDef: 'No integration field registered',
    },
  },
  activityCalendarEventForm: {
    privateSchedule: 'Private Schedule',
    viewAllGroupClients: 'View in All Group Clients',
  },
  attachmentsViewer: {
    type: {
      frontage: 'Storefront photo',
      order: 'Orders',
      visitation: 'Visits',
      other: 'Other attachments',
      processo: 'Processes',
    },
    filter: {
      searchOnAttachments: 'Search attachments',
      type: 'Attachment type',
      user: 'Added by',
      flow: 'Flow',
    },
    error: {
      openProcess: 'Unable to open process.',
      loadProcess: 'Unable to load process attachments.',
    },
  },
  crmAttachmentsViewerDetailsDialog: {
    label: {
      date: 'Date',
      type: 'Attachment type',
      description: 'Description',
    },
    type: {
      frontage: 'Storefront photo',
      order: 'Orders',
      visitation: 'Visits',
      other: 'Other attachments',
      processo: 'Processes',
    },
  },
};
